/**
 * @generated SignedSource<<e6c3041220dc4e436c51f7e39873f6f1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AssetStatus = "AVAILABLE" | "IN_USE" | "LOST" | "MAINTENANCE" | "RETIRED" | "%future added value";
export type EquipmentCategory = "AUDIO_VIDEO" | "BATTERY" | "CABLE" | "CAMERA" | "CAMERA_ACCESSORY" | "ETC" | "KIT" | "LENS" | "LIGHTING" | "MEDIA" | "NETWORK" | "POWER" | "PRINTER" | "SECURITY" | "WORKSTATION" | "WORKSTATION_ACCESSORY" | "%future added value";
export type CreateAssetInput = {
  assetTag?: any | null | undefined;
  category: EquipmentCategory;
  clientMutationId?: string | null | undefined;
  dailyRate?: number | null | undefined;
  description?: string | null | undefined;
  kitTag?: any | null | undefined;
  make?: string | null | undefined;
  model?: string | null | undefined;
  notes?: string | null | undefined;
  ownerId?: string | null | undefined;
  parentAssetTag?: any | null | undefined;
  properties?: ReadonlyArray<PropertyInput> | null | undefined;
  rentable?: boolean | null | undefined;
  replacementValue?: number | null | undefined;
  serial?: string | null | undefined;
  status?: AssetStatus | null | undefined;
};
export type PropertyInput = {
  key: string;
  value: string;
};
export type OpsAssetPageCreateMutation$variables = {
  input: CreateAssetInput;
};
export type OpsAssetPageCreateMutation$data = {
  readonly createAsset: {
    readonly asset: {
      readonly id: string;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type OpsAssetPageCreateMutation = {
  response: OpsAssetPageCreateMutation$data;
  variables: OpsAssetPageCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateAssetPayload",
    "kind": "LinkedField",
    "name": "createAsset",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Asset",
        "kind": "LinkedField",
        "name": "asset",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsAssetPageCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OpsAssetPageCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "73c145ac4a5bf78745725a8c3610c37c",
    "id": null,
    "metadata": {},
    "name": "OpsAssetPageCreateMutation",
    "operationKind": "mutation",
    "text": "mutation OpsAssetPageCreateMutation(\n  $input: CreateAssetInput!\n) {\n  createAsset(input: $input) {\n    asset {\n      id\n    }\n    userErrors {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "367722edf61a7964b9f4884c2c782469";

export default node;
